import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck, OnDestroy } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import * as encoding from 'encoding-japanese';
import { ShipService } from '../../../service/ship/ship.service';
import { ShipInvoiceService } from '../../../service/ship-invoice/ship-invoice.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3000.component.html',
  styleUrls: ['wa3000.component.scss']
})
export class Wa3000Component implements AfterViewInit, OnDestroy {

  @ViewChild('contentHeader')
  contentHeader: ElementRef;

  @ViewChild('tableNavWrap')
  tableNavWrap : ElementRef;

  @ViewChild('graphBlockWrap')
  graphBlockWrap : ElementRef;

  private timerID = null;

  private owners = [];
  private isTableOpened = false;

  constructor(
    private router: Router,
    private shipService: ShipService,
    private shipInvoiceService: ShipInvoiceService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
  }


  ngAfterViewInit() {
    this.timerID = setInterval(()=>{
      document.getElementById("currentDate").innerHTML = this.getNow();
    },1000);

    var blockPosition = this.offset(this.graphBlockWrap.nativeElement).top;
    var graphBlock = this.graphBlockWrap.nativeElement.querySelector('.graphBlock');

		var triggerPosition = this.offset(graphBlock).top - blockPosition;
    this.graphBlockWrap.nativeElement.addEventListener('scroll', ()=>{

      var navPosition = this.offset(this.tableNavWrap.nativeElement).top;
      var navHeight= this.tableNavWrap.nativeElement.offsetHeight;
      var position = navPosition + navHeight +1;

			var ww = this.contentHeader.nativeElement.offsetWidth;
      var graphBlockHead = this.graphBlockWrap.nativeElement.querySelector('.graphBlockHead');
      var gbhw = graphBlockHead.offsetWidth;
			var scrollbar = ww - gbhw -60;

      if (this.graphBlockWrap.nativeElement.scrollTop > 0) {

        this.graphBlockWrap.nativeElement.classList.add('fixed');
        graphBlock.style.marginTop = triggerPosition -25 + 'px';
        graphBlockHead.style.top = position + 'px';
        graphBlockHead.style.paddingRight = scrollbar + 'px';
      }
      else {
        this.graphBlockWrap.nativeElement.classList.remove('fixed');
        graphBlock.style.marginTop = 'auto';
        graphBlockHead.style.paddingRight = '0px';
      }
    });
    this.requestOwners();
  }

  ngOnDestroy() {
    clearInterval(this.timerID);
  }

  getNow() {
		var dateObj = new Date();
		var y = dateObj.getFullYear();
		var m = dateObj.getMonth()+1; //１を足すこと
		var d = dateObj.getDate();
		var hh = dateObj.getHours();
		var mm = ("0"+dateObj.getMinutes()).slice(-2);

		//出力用
		var set1 = "<small>"+y+"/"+m+"/"+d+"</small>"+hh+"<span>:</span>"+mm;
		return set1;
	}

  onTableNavClick() {
    let isOpenTable = this.tableNavWrap.nativeElement.classList.contains('openTable');
    if (isOpenTable)
      this.tableNavWrap.nativeElement.classList.remove('openTable');
    else
      this.tableNavWrap.nativeElement.classList.add('openTable');

    let navPosition = this.offset(this.tableNavWrap.nativeElement).top;
    let navHeight = this.tableNavWrap.nativeElement.offsetHeight;

    var position = navPosition + navHeight +1;
    let graphBlockHead = this.graphBlockWrap.nativeElement.querySelector('.graphBlockHead');
    graphBlockHead.style.top = position +'px';

    var gbH = this.graphBlockWrap.nativeElement.offsetHeight;
    var tnwH = this.tableNavWrap.nativeElement.offsetHeight;

    var calc = gbH - tnwH + 40;
    if (!isOpenTable) {
      this.graphBlockWrap.nativeElement.style.height = calc + 'px';
    }
    else {
      this.graphBlockWrap.nativeElement.style.height = 'calc(100% - 44px)';
    }
    this.isTableOpened = !this.isTableOpened;
  }

  offset(el) {
    var obj = {
      left: el.offsetLeft,
      top: el.offsetTop,
      width: el.offsetWidth,
      height: el.offsetHeight
    }
    while(el != document.body) {
      el = el.offsetParent;
      obj.left += el.offsetLeft;
      obj.top += el.offsetTop;
    }
    return obj;
  }


  changeOwner(selectedOwnerId) {
    this.requestOwners();
  }

  requestOwners() {
    var allOwners = null;
    var ownerResult = sessionStorage.getItem('ownerResult');
    if (ownerResult != null) {
      var ownerResultJSON = JSON.parse(ownerResult);
      if (ownerResultJSON.ownerId !== undefined) {
        allOwners = [ownerResultJSON];
        this.owners = allOwners;
      }
    }

    if (allOwners == null) {
      this.ownerService
            .get()
            .then(outputJson => {
              this.owners = outputJson.owners;
            })
            .catch(error => {
            });
    }
  }

  goFragment(location : string) {
    window.location.hash = '';
    window.location.hash = 'id_' + location;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3000/wa3000.component.ts